import React from 'react';
import PropTypes from 'prop-types';
import content from '../../locales/en/content.json';

const SubmitLoadingIndicator = ({ submission }) => {
  const { hasAttemptedSubmit, status } = submission;
  const isLoading = hasAttemptedSubmit && status === 'submitPending';
  return isLoading ? (
    <va-loading-indicator
      message={content['form-submission-message']}
      class="vads-u-margin-y--4"
      set-focus
    />
  ) : null;
};

SubmitLoadingIndicator.propTypes = {
  submission: PropTypes.shape({
    hasAttemptedSubmit: PropTypes.bool,
    status: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
};

export default SubmitLoadingIndicator;
